import React, { useContext, useEffect, useState } from 'react';

// libraries
import { MdEditNote } from 'react-icons/md';
import { Avatar, Form, Input, Button } from 'antd';
import { AiOutlineEdit } from "react-icons/ai";

// components
import Loading from '../common/Loading';
import Error from '../common/Error';
import BotResponse from './BotResponse';
import { botIconsMap } from '../../constants/chatPageConstants';
import CodeInterPreterOutput from './CodeInterPreterOutput';
import UserPrompt from './UserPrompt';
import { getUserID } from "../../Utility/service";
import { getUserAvatar } from "../../api/userApiFunctions";
import UserAvatar from '../UserAvatar/UserAvatar';
import { ProfileContext } from '../../contexts/ProfileContext';
import { useLocation } from 'react-router-dom';

const MessageContainer = ({ states }) => {
  const { chat, idx, loading, error } = states;
  
  const getProviderIcon = () => {
    const rawProvider = chat?.botProvider || 
                       chat?.provider || 
                       chat?.chatModel || 
                       chat?.selectedChatModel ||
                       chat?.bot ||
                       'openai'; 
    
    let provider = rawProvider;
    if (rawProvider === 'custom') {
      provider = chat?.modelused || chat?.model || 'openai';
      
      if (provider === 'custom' || !botIconsMap[provider]) {
        const modelName = chat?.modelused || chat?.model || '';
        
        if (modelName.toLowerCase().includes('gpt') || modelName.toLowerCase().includes('openai')) {
          provider = 'openai';
        } else if (modelName.toLowerCase().includes('gemini') || modelName.toLowerCase().includes('google')) {
          provider = 'gemini';
        } else if (modelName.toLowerCase().includes('claude') || modelName.toLowerCase().includes('anthropic')) {
          provider = 'claude';
        } else if (modelName.toLowerCase().includes('deepseek')) {
          provider = 'deepseek';
        } else {
          provider = 'openai'; // final fallback
        }
      }
    }    
    const iconData = botIconsMap[provider] || botIconsMap.openai;
    return iconData?.icon || botIconsMap.openai?.icon;
  };

  const botProviderIcon = getProviderIcon();
  const userIcon = botIconsMap.user.icon;

  const isBotMessageReceived = chat?.botMessage || false;
  const isCodeInterpreterOutputReceived = chat?.codeInterpreterOutput || false;

  const { userAvatar } = useContext(ProfileContext);

  const isPropsExistForEdit = states.hasOwnProperty('editProps') || false;

  const [bgColor, setBgColor] = useState("#ffffff");
  const [fontSize, setFontSize] = useState("16px");
  const [textColor, setTextColor] = useState("#000000");
  const [themeColor, setThemeColor] = useState("#F9FAFB");

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let colorFromUrl = queryParams.get("color");
    let textColorFromUrl = queryParams.get("textColor");
    let themeColorFromUrl = queryParams.get("themeColor");

    if (colorFromUrl) {
      colorFromUrl = colorFromUrl === "red" ? "#ff0000" : colorFromUrl;
      setBgColor(colorFromUrl);
    }

    if (textColorFromUrl) {
      setTextColor(textColorFromUrl);
    }

    if (themeColorFromUrl) {
      setThemeColor(themeColorFromUrl);
    }
  }, [location]);

  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    const embeddedParam = new URLSearchParams(window.location.search).get("embedded") === "true";
    setIsEmbedded(embeddedParam);
  }, []);

  return (
    <div className="chatLog" key={chat.msg_id || idx}>
      {/* ----- USER PROMPT ----- */}
      <div className="chatPromptMainContainer">
        <div
          className="chatPromptWrapper"
          style={{
            maxWidth: "48rem",
          }}
        >
          {userAvatar ? (
            <UserAvatar
              userAvatar={userAvatar}
              width={40}
              height={30}
              shape="square"
            />
          ) : (
            <Avatar
              width={40}
              height={30}
              src={userIcon}
              className='userIcon'
            />
          )}

          <UserPrompt
            states={{
              chat,
              ...(isPropsExistForEdit && { editProps: states.editProps })
            }}
          />
        </div>
      </div>

      {/* ----- BOT RESPONSE ----- */}
      <div className="botMessageMainContainer">
        <div
          className="botMessageWrapper mb-3"
          style={{
            maxWidth: "48rem",
            backgroundColor: isEmbedded ? themeColor : {},
          }}
        >
          <div>
            <Avatar src={botProviderIcon} />
          </div>
          {isBotMessageReceived || isCodeInterpreterOutputReceived ? (
            <>
              <div id="botMessage">
                <div className="tagSection">
                  {chat?.tags?.length > 0 &&
                    chat?.tags?.map((tag, tagIdx) => (
                      <p key={tagIdx} className="tag">
                        {tag.title}
                      </p>
                    ))}
                </div>

                {isCodeInterpreterOutputReceived ? (
                  <CodeInterPreterOutput output={chat.codeInterpreterOutput} />
                ) : null}
                {isBotMessageReceived ? (
                  <BotResponse
                    chatPrompt={chat?.chatPrompt}
                    response={chat.botMessage}
                  />
                ) : null}
                <div className="model-token-container">
                  {chat.modelUsed ? <p>Model : {chat?.modelUsed}</p> : null}
                  {chat.tokenUsed ? <p>Token : {chat?.tokenUsed}</p> : null}
                </div>
              </div>
            </>
          ) : loading ? (
            <Loading />
          ) : error ? (
            <Error message={error} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MessageContainer;